var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dialogVisible
    ? _c(
        "member-info",
        {
          attrs: {
            show: _vm.dialogVisible,
            data: _vm.memberInfo,
            title: "给用户转账",
          },
          on: {
            "update:show": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.dialogClose,
            submit: _vm.handleSubmit,
          },
        },
        [
          _c(
            "el-descriptions-item",
            { attrs: { label: "转入积分" } },
            [
              _c("el-input", {
                staticClass: "max-width",
                attrs: {
                  type: "number",
                  placeholder: "请输入要转入的积分数量",
                },
                model: {
                  value: _vm.wallet.transferPoint,
                  callback: function ($$v) {
                    _vm.$set(_vm.wallet, "transferPoint", $$v)
                  },
                  expression: "wallet.transferPoint",
                },
              }),
            ],
            1
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: "转入券" } },
            [
              _c("el-input", {
                staticClass: "max-width",
                attrs: { type: "number", placeholder: "请输入要转入的券数量" },
                model: {
                  value: _vm.wallet.coupon,
                  callback: function ($$v) {
                    _vm.$set(_vm.wallet, "coupon", $$v)
                  },
                  expression: "wallet.coupon",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }